module.exports = __webpack_public_path__ + "img/fate_f.immersys.b9eaec3.png";